import carouselBanner1 from "../images/Banner/banner1.png";
import carouselBanner2 from "../images/Banner/banner2.png";
import carouselBanner3 from "../images/Banner/banner3.png";
import carouselBanner4 from "../images/Banner/banner4.png";
import carouselBanner5 from "../images/Banner/banner5.png";

export const carouselData = [
  {
    _id: "mnaCarWarehouseCarouselBanner001",
    title: "Discover Your Dream Car",
    subtitle: "Explore our exclusive collection of luxury vehicles",
    img: carouselBanner1,
    buttonText: "Browse Collection",
  },
  {
    _id: "mnaCarWarehouseCarouselBanner002",
    title: "Unmatched Performance",
    subtitle: "Experience the thrill of driving with our high-performance cars",
    img: carouselBanner2,
    buttonText: "View Performance Cars",
  },
  {
    _id: "mnaCarWarehouseCarouselBanner003",
    title: "Luxury Redefined",
    subtitle: "Step into a world of elegance and comfort with our luxury range",
    img: carouselBanner3,
    buttonText: "Explore Luxury Cars",
  },
  {
    _id: "mnaCarWarehouseCarouselBanner004",
    title: "Eco-Friendly Options",
    subtitle: "Go green with our selection of hybrid and electric vehicles",
    img: carouselBanner4,
    buttonText: "Discover Eco Cars",
  },
  {
    _id: "mnaCarWarehouseCarouselBanner005",
    title: "Affordable Deals",
    subtitle: "Find the best deals on used cars without compromising quality",
    img: carouselBanner5,
    buttonText: "Shop Used Cars",
  },
];
